var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F2F1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.34167 3.33203C8.0258 3.45203 6.78379 3.96536 5.76333 4.7987L6.72337 5.82536C7.47529 5.22536 8.38162 4.8387 9.34167 4.70536V3.33203ZM4.81671 5.7787C3.97425 6.78845 3.45727 8.02657 3.33301 9.33203H4.67572C4.80328 8.38536 5.17924 7.48536 5.77675 6.73203L4.81671 5.7787ZM3.33972 10.6654C3.47399 11.972 3.99094 13.2054 4.82342 14.2187L5.77675 13.2654C5.18384 12.5118 4.80587 11.6138 4.68244 10.6654H3.33972ZM6.69651 14.2454L5.76333 15.1587C6.78041 16.0003 8.02537 16.5245 9.34167 16.6654V15.332C8.38657 15.2095 7.48224 14.8341 6.72337 14.2454H6.69651Z",
    fill: "#4F43A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8341 3.33203C12.15 3.45203 13.392 3.96536 14.4125 4.7987L13.4524 5.82536C12.7005 5.22536 11.7942 4.8387 10.8341 4.70536V3.33203ZM15.3591 5.7787C16.2015 6.78845 16.7185 8.02657 16.8428 9.33203H15.5001C15.3725 8.38536 14.9965 7.48536 14.399 6.73203L15.3591 5.7787ZM16.8361 10.6654C16.7018 11.972 16.1848 13.2054 15.3524 14.2187L14.399 13.2654C14.9919 12.5118 15.3699 11.6138 15.4933 10.6654H16.8361ZM13.4793 14.2454L14.4125 15.1587C13.3954 16.0003 12.1504 16.5245 10.8341 16.6654V15.332C11.7892 15.2095 12.6935 14.8341 13.4524 14.2454H13.4793Z",
    fill: "#4F43A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessing);
export default __webpack_public_path__ + "static/media/processing.056415cc05ed0edc4ddf83df06a1243d.svg";
export { ForwardRef as ReactComponent };